export default __webpack_public_path__ + "static/media/ic-hourglass.764117f1.svg";